import React, { useState } from 'react';
import { Divider, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, makeStyles } from '@material-ui/core';
import Loader from '../atoms/Loader';
import { COLOR_BACKGROUND_LIGHT, COLOR_BLACK, COLOR_BORDER, COLOR_DARK_GRAY, COLOR_LIGHT_GRAY, COLOR_SHADOW, COLOR_WHITE } from '../styles/colors';
import OurladsFileUploads from '../types/OurladsFileUploads';
import { datetimeToDate } from '../services/converter';
import clsx from 'clsx';
import MEDIA from '../styles/media';
import Pagination from '../atoms/Pagination';

interface ImportDepthChartActivityTableProps {
  ourladsFileUploads: any[];
  handleRowClick: (data: any) => void;
  fileNameAndDate: any;
  currentActivity: number;
  setCurrentActivity: (value: number) => void,
  limit: number;
}

const useStyles = makeStyles(theme => ({
  activityWrap: {
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    position: 'relative',
  },
  tableWrap: {
    boxShadow: `0 10px 10px 0 ${COLOR_SHADOW}`,
    border: `1px solid ${COLOR_LIGHT_GRAY}`,
    cursor: 'default', 
    overflow: 'auto',
  },

  tableHeadCell: {
    padding: theme.spacing(1.5, 0, 1.5, 1.5),
    fontSize: theme.typography.pxToRem(14),
    color: COLOR_DARK_GRAY,
    borderBottom: `1px solid ${COLOR_BORDER}`,

    '&:first-of-type': {
      paddingLeft: theme.spacing(1.5),
    },
    '&:last-of-type': {
      paddingRight: theme.spacing(1.5),
    },
  },
  tableRow: {
    background: COLOR_BACKGROUND_LIGHT,
    cursor: 'pointer',

    '&:nth-of-type(2n)': {
      background: COLOR_WHITE,
    }
  },
  tableCell: {
    border: 0,
    color: COLOR_DARK_GRAY,
    fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(1, 0, 1, 1),
    textTransform: 'capitalize',

    '&:first-of-type': {
      paddingLeft: theme.spacing(2),
    },

    '&:last-of-type': {
      width: '20%',
    },
  },
  ellipsisCell: {
    maxWidth: '150px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  selectedTableCell: {
    color: COLOR_BLACK
  },
  paginationWrapper: {
    padding: '0 20px',
  },
  paginationContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    minHeight: '24px',
    padding: theme.spacing(3, 0),
    position: 'relative',
  },
  pagination: {
    width: '100%',
  },
  paginationText: {
    marginTop: theme.spacing(2),
  },
}));

export default function ImportDepthChartActivityTable(props: ImportDepthChartActivityTableProps) {
  const {
    ourladsFileUploads,
    handleRowClick,
    fileNameAndDate,
    currentActivity,
    setCurrentActivity,
    limit
  } = props;
  const classes = useStyles();
  const totalPages = ourladsFileUploads && Math.ceil(ourladsFileUploads.length / limit);
  const itemsFrom = (currentActivity - 1) * limit;
  const itemsTo = ourladsFileUploads && ourladsFileUploads.length < limit ? ourladsFileUploads.length : (limit * currentActivity);

  function selectedRowIsTrue(id: number) {
    const selectedRowId = fileNameAndDate && fileNameAndDate.id;
    return id === selectedRowId;
  }

  function renderTableRow(data: OurladsFileUploads, index: number) {
    const {
      id,
      fileName,
      // fileUrl,
      createdAt,
      status
    } = data;
    return (
      <TableRow
        key={`${id}_${index}`}
        className={classes.tableRow}
        onClick={() => handleRowClick(data)}
      >
        <TableCell className={clsx(classes.tableCell, classes.ellipsisCell, (selectedRowIsTrue(id) ? classes.selectedTableCell : ''))} align='center'>{fileName}</TableCell>
        <TableCell className={clsx(classes.tableCell, (selectedRowIsTrue(id) ? classes.selectedTableCell : ''))} align='center'>{datetimeToDate(createdAt)}</TableCell>
        <TableCell className={clsx(classes.tableCell, (selectedRowIsTrue(id) ? classes.selectedTableCell : ''))} align='center'>{status}</TableCell>
      </TableRow>
    )
  };

  function renderTable() {
    return (
      <>
        <div className={classes.tableWrap}>
        {ourladsFileUploads && ourladsFileUploads.length ? 
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeadCell} align='center'>File</TableCell>
                <TableCell className={classes.tableHeadCell} align='center'>Date</TableCell>
                <TableCell className={classes.tableHeadCell} align='center'>Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {ourladsFileUploads
                .slice(itemsFrom, itemsTo)
                .map(renderTableRow)}
            </TableBody>
          </Table>
          <div className={classes.paginationWrapper}>
            <div className={classes.paginationContainer}>
              <span className={classes.paginationText}>
                Showing {itemsFrom + 1} to {itemsTo} of {ourladsFileUploads.length}
              </span>

              {totalPages > 1 && (
                <Pagination
                  className={classes.pagination}
                  currentPage={currentActivity}
                  totalPages={totalPages}
                  onChange={page => setCurrentActivity(page)}
                />
              )}
            </div>
          </div>
          </>
          : 
          <Typography>No Data Found</Typography>
        }
        </div>
      </>
    );
  }

  return (
    <Paper>
      {/* <Loader inProgress={loading} /> */}
      {renderTable()}
      <Divider variant='fullWidth' light />
    </Paper>
  )
}
